module.exports = __webpack_public_path__ + "img/5.86085b6b.jpg";